import { Language } from "../languages/labels/language.labels";
import { GroupOptions } from "../models/group.options.model"
import { statusDocumentValue } from "./status.document.library";
import { validityValue } from "./validation.library";
import { expirationValue } from "./expiration.library";
import { monthValue } from "./month.library";
import { paymentAllValue } from "./payment.library";

export function nameGroup(lang: Language, key: string, group_detail: GroupOptions): string {
  switch (key) {
    case 'customer':
      return `${group_detail.customer}`
    case 'provider':
      return `${group_detail.provider}`
    case 'treasury':
      return `${group_detail.treasury}`
    case 'validity':
      return `${validityValue(lang, group_detail.validity)}`
    case 'status':
      return `${statusDocumentValue(lang, group_detail.status)}`
    case 'expiration':
      return `${expirationValue(lang, group_detail.expiration)}`
    case 'payment':
      return `${paymentAllValue(lang, group_detail.payment)}`
    case 'year':
      return `${group_detail.year}`
    case 'month':
      return `${group_detail.year} - ${monthValue(lang, group_detail.month)}`
    case 'week':
      return `${group_detail.year} - ${lang.labels.week} ${group_detail.week.padStart(2, '0')}`
    case 'day':
      return `${group_detail.year} - ${monthValue(lang, group_detail.month)} - ${group_detail.day.padStart(2, '0')}`
    default:
      return lang.labels.notGrouped
  }
}
